import React from 'react';
import Biofuel from '../images/biofuel.png';
import Bioeconomy from '../images/circular bioeconomy.png';

export default function About() {
    return (
        <>
            <section id="about_sec" className="about_sec">
                <div className="about_para_box">
                    <div className="wrapper">
                        <div className="static_txt">We </div>
                        <ul className="dynamic_txts ">
                            <li><span>Refine</span></li>
                            <li><span>Reuse</span></li>
                            <li><span>Recycle</span></li>
                        </ul>
                    </div>
                    <div className="about_p1_outer">
                        <div className="about_p1 h2">
                            Established in 2024, Chrissron Biomass Solutions Pvt. Ltd. is the culmination of over a decade of research and testing conducted by our founders. It symbolizes their unwavering determination and hard work dedicated to realizing their dreams. The startup focuses on offering environmentally-friendly technology to transform agricultural wastes, which are plentiful and pose an environmental challenge, into bio-based products. The conversion of these waste materials into value-added products contributes to fostering a circular economy, offering a sustainable solution through a biorefinery approach.
                        </div>
                    </div>
                </div>

            </section>

            <section class="future_vision">
                <div class="vision_heading h1">Our Vision</div>
                <div class="products_box">
                    <div class="products" id="project1">
                        <div class="odd">
                            <a href="https://shashwatkedia.github.io/EcoHub/" target="_blank">
                                <img src={Biofuel} alt="" srcset="" class="products_img" />
                            </a>
                        </div>
                        <div class="products_card">
                            <div class="products_heading">BioFuels</div>
                            <div class="products_text">
                                The company is actively exploring the development of diverse bioproducts, including biofuels derived from agricultural wastes, with potential applications in agriculture, textiles, and more. A functional prototype for producing biofuel from biomass has been successfully developed at the laboratory level. Our next objective is to scale up production to an industrial level, enabling widespread accessibility. The company is dedicated to offering a sustainable alternative to the challenges posed by synthetic and fossil-based chemicals. Our overarching goal is to advocate for green technology, contributing to a better future by prioritizing environmentally-friendly solutions and fostering positive changes in the industry.
                            </div>
                        </div>
                    </div>
                    <div class="products" id="project2">
                        <div class="even">
                            <a href="https://shashwatkedia.github.io/TicTacToe/" target="_blank">
                                <img src={Bioeconomy} alt="" srcset="" class="products_img" />
                            </a>
                        </div>
                        <div class="products_card">
                            <div class="products_heading">Circular Bioeconomy</div>
                            <div class="products_text">
                                Chrissron plays a pivotal role in advancing the concept of a circular bioeconomy. By harnessing the potential of organic materials, we contribute to a sustainable cycle where agricultural waste is transformed into valuable bio-based products. Through innovative processes, we convert biomass into bioplastics and biofuels reducing dependency on finite resources. Our commitment to utilizing every component of biomass aligns with the principles of a circular bioeconomy, minimizing waste and promoting resource efficiency. This holistic approach not only addresses environmental challenges but also fosters economic growth by creating a closed-loop system that benefits both industry and the planet.
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>

    )
}
